import React from 'react';
import {
  StaticInstallmentsDescription,
  StaticInstallmentsDescriptionProps,
} from '../controller';
import { MoreInfoIframe } from '../MoreInfoIframe';
import { ClearpayCurrencySymbol, CLEARPAY_COUNTRIES } from '../constants';
import { buildAfterpayClearpayModalUrl } from '../utils';

export const INSTALLMENTS_NUMBER = 4;
export const INFO_MODAL_SIZE = {
  width: 780,
  height: 627,
};

export interface ClearpayDescriptionProps
  extends Omit<
    StaticInstallmentsDescriptionProps,
    'methodName' | 'intallmentsNumber' | 'moreInfo'
  > {
  country?: string;
}

export const ClearpayDescription: React.FunctionComponent<ClearpayDescriptionProps> =
  ({ deviceType, amount, currency, country, isSinglePaymentMethodOption }) => {
    const isCountrySupported = CLEARPAY_COUNTRIES.includes(country);
    const currencySymbol = ClearpayCurrencySymbol[currency];

    if (!isCountrySupported || !currencySymbol) {
      return null;
    }

    const infoModalUrl = buildAfterpayClearpayModalUrl(country);

    const moreInfoContent = infoModalUrl && (
      <MoreInfoIframe src={infoModalUrl} deviceType={deviceType} />
    );

    // we are getting from server f7da7147-483e-418d-9e7c-b2aa28212729
    // which is hardly readable and cannot be used for translation messages
    const readableMethodName = 'clearpay';

    return (
      <StaticInstallmentsDescription
        deviceType={deviceType}
        methodName={readableMethodName as any}
        amount={amount}
        currency={currencySymbol}
        intallmentsNumber={INSTALLMENTS_NUMBER}
        moreInfo={moreInfoContent}
        moreInfoSize={INFO_MODAL_SIZE}
        isSinglePaymentMethodOption={isSinglePaymentMethodOption}
      />
    );
  };
ClearpayDescription.displayName = 'ClearpayDescription';
